// extracted by mini-css-extract-plugin
module.exports = {"container":"MessageList_container__1ohet"};